import { ShoppingCart } from '@vi-succ/shoppingcart-domain';
import { environment } from '../environments/environment';

export class CartShareFactory {
  static build(cart: ShoppingCart, template: string): string {
    let items = '\n';
    cart.items.forEach((item) => {
      items += `- ${item.quantity} x ${item.product.materialDescription} (${item.product.materialNumber})\n`;
    });

    const commission = cart.commission + '\n';
    const link = this.buildUrl(cart);

    return template.replace('{{items}}', items).replace('{{commission}}', commission).replace('{{link}}', link);
  }

  static buildUrl(cart: ShoppingCart) {
    return `${environment.backend.shopUrl}?shopApiContext=viparts&redirectToCheckout=false&vipartsCart=${cart.id}`;
  }
}
